import { render, staticRenderFns } from "./MedicalRecordEdit.vue?vue&type=template&id=63e81902&scoped=true&"
import script from "./MedicalRecordEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordEdit.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordEdit.vue?vue&type=style&index=0&id=63e81902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e81902",
  null
  
)

export default component.exports